import { ReactNode } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { useSetWindowPrefs } from '@app/shared/hooks/useSetWindowPrefs';
import { isDailyEnergyRoute } from '@app/shared/utils/layout';
import { starryBgImage } from '@app/assets';
import { FOOTER_HEIGHT } from '@app/shared/constants/layout';

interface MainLayoutProps {
  children?: ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  const { pathname } = useLocation();
  const hasStarryBg = isDailyEnergyRoute(pathname);

  useSetWindowPrefs();

  return (
    <div
      className="theme-transition flex h-dvh max-h-dvh min-h-dvh flex-col bg-background bg-cover"
      style={{
        ...(hasStarryBg && {
          backgroundImage: `url(${starryBgImage})`,
        }),
      }}
    >
      <div
        className="mx-auto flex size-full max-w-[480px] flex-1 flex-col"
        style={{
          paddingTop:
            'calc(var(--tg-safe-area-inset-top, 0px) + var(--tg-content-safe-area-inset-top, 0px))',
          paddingRight: 'var(--tg-safe-area-inset-right, 0px)',
          paddingBottom: `calc(var(--tg-safe-area-inset-bottom, 0px) + ${String(FOOTER_HEIGHT - 40)}px)`,
          paddingLeft: 'var(--tg-safe-area-inset-left, 0px)',
        }}
      >
        <Outlet />
        {children}
      </div>
    </div>
  );
}
